module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Sun-fog-672b3496bddcc2d4553e572d9a8f1452.svg";